import gql from "graphql-tag"

export default gql`
  mutation AddUserToTeam($teamId: ID!, $userId: ID!, $assignment: TeamAssignment) {
    addUserToTeam(teamId: $teamId, userId: $userId, assignment: $assignment)
  }
`
